export default __webpack_public_path__ + "static/media/slide3.ba876e88.jpg";